/**
 * HTTP関連のユーティリティと定数
 * HTTPリクエスト・レスポンス処理のための共通定数と型定義
 *
 * Note: HTTP_STATUS は @/constants/errors から直接インポートしてください
 */

// HTTPメソッド定数
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
} as const

export type HttpMethod = (typeof HTTP_METHODS)[keyof typeof HTTP_METHODS]

// Content-Type定数
export const CONTENT_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
  URL_ENCODED: 'application/x-www-form-urlencoded',
  TEXT: 'text/plain',
  HTML: 'text/html',
  XML: 'application/xml',
  PDF: 'application/pdf',
  CSV: 'text/csv',
} as const

export type ContentType = (typeof CONTENT_TYPES)[keyof typeof CONTENT_TYPES]

// 共通HTTPヘッダー
export const COMMON_HEADERS = {
  AUTHORIZATION: 'Authorization',
  CONTENT_TYPE: 'Content-Type',
  ACCEPT: 'Accept',
  ACCEPT_LANGUAGE: 'Accept-Language',
  USER_AGENT: 'User-Agent',
  CACHE_CONTROL: 'Cache-Control',
  PRAGMA: 'Pragma',
  EXPIRES: 'Expires',
  X_REQUESTED_WITH: 'X-Requested-With',
  X_CSRF_TOKEN: 'X-CSRFToken',
} as const

// デフォルトタイムアウト設定（ミリ秒）
export const TIMEOUT_SETTINGS = {
  DEFAULT: 30000, // 30秒
  UPLOAD: 120000, // 2分（ファイルアップロード用）
  LONG_POLLING: 300000, // 5分（長時間ポーリング用）
  QUICK: 5000, // 5秒（軽量リクエスト用）
} as const

// リトライ設定
export const RETRY_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1秒
  RETRY_MULTIPLIER: 2, // 指数バックオフ係数
  MAX_RETRY_DELAY: 10000, // 最大10秒
} as const
